"use strict";

var _jquery = require("jquery");
var _jquery2 = _interopRequireDefault(_jquery);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(0, _jquery2.default)(function () {
  (0, _jquery2.default)('.template-section-menu ul').each(function (index, element) {
    if ((0, _jquery2.default)('li', (0, _jquery2.default)(element)).length <= 3) {
      (0, _jquery2.default)('.slick-arrow', (0, _jquery2.default)(element).parent()).hide();
      return;
    }
    var tagArrowLeft = (0, _jquery2.default)(element).data('tag-arrow-left');
    var tagArrowRight = (0, _jquery2.default)(element).data('tag-arrow-right');
    (0, _jquery2.default)(element).on('init', function (event, slick, direction) {
      (0, _jquery2.default)('.slick-slide a', (0, _jquery2.default)(element)).each(function (index2, element2) {
        var id = (0, _jquery2.default)(element2).data('id');
        (0, _jquery2.default)(element2).attr('id', id);
      });
    });
    (0, _jquery2.default)(element).slick({
      dots: true,
      arrows: true,
      mobileFirst: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: false,
      appendDots: (0, _jquery2.default)('.container-dots', (0, _jquery2.default)(element).closest('.template-section-menu')),
      prevArrow: (0, _jquery2.default)('.button-arrow-prev', (0, _jquery2.default)(element).closest('.section-menu')),
      nextArrow: (0, _jquery2.default)('.button-arrow-next', (0, _jquery2.default)(element).closest('.section-menu'))
    });
  });
});